<template>
    <Vin 
     :formTitle="textObj.formTitle"
      :vin="vinValue" 
      :model="modelValue" 
      :vinLabel="textObj.vinLabel"
      :modelLabel="textObj.modelLabel"
      :isLoading="isLoading"
      :isSuccess="isSuccess"
      :isFail="isFail"
      :failMessage="failMessage"
      :resultData="resultData"
      :successColor="'rgba(248, 177, 33, 0.1)'"
      >
    <!-- 使用共享的成功内容组件 -->
      <template v-slot:success-content>
        <VinSuccessContent :resultData="resultData" />
      </template>
      <!-- 使用共享的失败内容组件 -->
      <template v-slot:fail-content>
        <VinFailContent 
          :failMessage="failMessage" 
        />
      </template>
    </Vin>
</template>
<script>
import sessionAPI from '@/api/session'
import Vin from '../pc/message/message-elements/vin.vue'
import { updateQueryResult, getUserRealtiveInfo, getSignFromUrl } from '../pc/message/message-elements/vin-ota/common-untils'
import VinSuccessContent from '../pc/message/message-elements/vin-recall/vin-success-content.vue'
import VinFailContent from '../pc/message/message-elements/vin-recall/vin-fail-content.vue'
import vinOtaData from '../pc/message/message-elements/vin-recall/vin-recall-data'
import { DEFAULT_FAIL_MESSAGE } from '../pc/message/message-elements/vin-recall/vin-recall-data'

export default {
    components:{Vin,VinSuccessContent, VinFailContent},
      data() {
        return {
        // 从共享配置导入
        textObj: vinOtaData.textObj,
        // 状态管理
        isLoading: true,
        isSuccess: false,
        isFail: false,
        vinValue: '',
        modelValue: '',
        resultData: null,
        failMessage: ''
        }
    },
    async mounted() {
        try {
          // 获取URL上的sign参数
          this.sign = getSignFromUrl()
          
          // 调用getUserRealtiveInfo获取用户相关信息
          await getUserRealtiveInfo({ instance: this })
           console.log('请求两个桥后的this.vinValue==>',this.vinValue,'请求两个桥后的this.userID==>',this.userID)
          // 只有当有userID都有值时才去请求
          if (this.userID) {
            // 调用查询接口
            this.queryVINRecallInfo()
          } else {
            // 参数不完整，显示错误信息
            this.isLoading = false
            this.isFail = true
            this.failMessage = DEFAULT_FAIL_MESSAGE
          }
        } catch (error) {
          console.log('请求两个桥后的被reject了==>',error)
          // 两个桥中有一个失败，执行失败逻辑
          this.isLoading = false
          this.isFail = true
          this.failMessage = DEFAULT_FAIL_MESSAGE
        }
    },
    methods: {
    // 查询VIN 召回信息
    async queryVINRecallInfo() {
      try {
        this.isLoading = true
        this.isSuccess = false
        this.isFail = false
        this.failMessage = ''
        
        // 调用接口
        const response = await sessionAPI.queryVINRecall({
          vin: this.vinValue,
          userId: this.userID,
          sign: this.sign,
          carSeries:this.modelValue
        })
         console.log('queryVINRecall 请求返回:', response)
        
        updateQueryResult({instance:this, defaultFailMsg:'未查询到车辆召回信息',response,isApp:true})
       
      } catch (error) {
       console.log('queryVINRecall 请求失败报错==>',error)
        // 处理失败响应
        this.isLoading = false
        this.isFail = true
        
        // 根据错误类型设置失败消息
        if (error.code === 'ECONNABORTED') {
          this.failMessage = DEFAULT_FAIL_MESSAGE
          console.log('查询超时')
        } else {
          this.failMessage = DEFAULT_FAIL_MESSAGE
        }
        
        console.error('查询VIN 升级信息失败:', error)
      }
    },
    
    /**
     * 处理FAQ点击事件
     * @param {string} item - 点击的FAQ内容
     */
    // handleQuestionClick(item) {
    //   console.log('移动端点击FAQ:', item)
    //   // 这里可以根据需要添加处理逻辑
    //   // 例如：发送消息到服务器或调用其他方法
    // }
  }
}
</script>